import { connect } from 'react-redux';

const mapStateToProps = ({ NewOrderReducer: order }) => ({
  $state: order,
});

export default connect(mapStateToProps);
